import { render, staticRenderFns } from "./PropertyFormAdditionalInfo.vue?vue&type=template&id=44600282&scoped=true&"
import script from "./PropertyFormAdditionalInfo.vue?vue&type=script&lang=ts&"
export * from "./PropertyFormAdditionalInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyFormAdditionalInfo.vue?vue&type=style&index=0&id=44600282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44600282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
